import React, { useState } from "react";

type CustomImgProps = {
  imgSrc: string;
  alt: string;
  className: string;
  loadingClass?: string;
  loadingClassSpan?: string;
  errorSource?: string;
  onClick?: () => void;
};

const CustomImg: React.FC<CustomImgProps> = ({
  imgSrc,
  alt,
  className,
  errorSource,
  loadingClass,
  loadingClassSpan,
  onClick
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div className={`text-center text-secondary ${loadingClass || ""}`}>
          <span
            className={`loading loading-ring loading-lg m-1 ${loadingClassSpan || ""}`}
          ></span>
        </div>
      )}
      <img
        src={imgSrc}
        alt={alt}
        className={`${className} ${isLoading ? "hidden" : ""}`}
        onClick={onClick}
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          setIsLoading(false);
          e.currentTarget.src = errorSource
            ? errorSource
            : "/assets/images/icons/camera-slash-solid.svg";
        }}
      />
    </>
  );
};
export default CustomImg;
